import axios from "axios";
import { getAuthRoute } from "../lib/routes";
import LocalStorageService from "./LocalStorageService";
import { getAuthOptions } from "./utils/getAuthOptions";

const AuthService = {
  login({ login, password, tenant }) {
    return axios.post(
      getAuthRoute(),
      `username=${encodeURIComponent(login)}&password=${encodeURIComponent(password)}&tenant_id=${tenant}&grant_type=password`,
      {
        auth: getAuthOptions(),
        validateStatus(status) {
          return status >= 200 && status < 300;
        },
      }
    );
  },
  getCurrentUser() {
    return LocalStorageService.getAccessToken();
  },
  refreshToken() {
    axios
      .post(
        getAuthRoute(),
        `grant_type=refresh_token&refresh_token=${LocalStorageService.getRefreshToken()}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            GrandType: "refresh_token",
          },
          auth: getAuthOptions(),
        }
      )
      .then((res) => {
        LocalStorageService.setToken(res?.data);
      });
  },
};

export default AuthService;
